import React from 'react'

export const PRACTICE_PATH = '/practice/writing-programs'
export const LANGUAGE_LABELS = { python: 'Python', javascript: 'JavaScript' }
export const LEVEL_LABELS = { basic: 'Basic', tough: 'Tough' }

// Remembered per browser; failures (private mode, blocked storage) fall back to Python.
export function preferredLanguage() {
  try { return localStorage.getItem('stPracticeLanguage') || 'python' } catch { return 'python' }
}
export function rememberLanguage(language) {
  try { localStorage.setItem('stPracticeLanguage', language) } catch { /* not important */ }
}

// 75 -> "1m 15s", 3900 -> "1h 05m"
export function formatDuration(seconds) {
  if (seconds === null || seconds === undefined) return '—'
  const s = Math.round(seconds)
  if (s < 60) return `${s}s`
  const m = Math.floor(s / 60)
  if (m < 60) return `${m}m ${String(s % 60).padStart(2, '0')}s`
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`
}

export function StatusBadge({ status }) {
  const map = {
    'solved-own': ['✓ Solved on your own', 'std-badge-ok'],
    'solved-hints': ['✓ Solved with hints', 'std-badge-ok'],
    started: ['In progress', 'std-badge-warn'],
    new: ['Not started', '']
  }
  const [text, cls] = map[status] || map.new
  return <span className={`std-badge ${cls}`}>{text}</span>
}

// A pattern's worked example: problem, steps, hand trace and code in the chosen language.
export function WorkedExample({ example, language }) {
  return (
    <div className="std-small">
      <p style={{ margin: '6px 0' }}><strong>Example:</strong> {example.problem}</p>
      <ol style={{ paddingLeft: 20, margin: '6px 0' }}>
        {example.steps.map((s, i) => <li key={i}>{s}</li>)}
      </ol>
      <div className="std-grid-2">
        <div><div className="std-muted">Trace by hand</div><pre className="std-pre std-pre-light">{example.trace}</pre></div>
        <div><div className="std-muted">Code ({LANGUAGE_LABELS[language]})</div><pre className="std-pre">{example.code[language]}</pre></div>
      </div>
    </div>
  )
}
